import { render, staticRenderFns } from "./TA6.vue?vue&type=template&id=08c247eb&"
import script from "./TA6.vue?vue&type=script&lang=js&"
export * from "./TA6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports